export default class SingleUploadAdapter {
  private loader: any;

  constructor(loader: any) {
    this.loader = loader;
  }

  upload() {
    return this.loader.file.then(
      (file: File) =>
        new Promise((resolve, reject) => {
          try {
            const blobUrl = URL.createObjectURL(file);

            window.dispatchEvent(
              new CustomEvent("ckeditor-image-upload", {
                detail: { file, src: blobUrl },
              })
            );

            resolve({
              default: blobUrl,
            });
          } catch (err) {
            reject(err);
          }
        })
    );
  }

  abort() {
    console.log("Upload aborted");
  }
}
